import { NavigationEvent } from '@spartacus/storefront'
import { Injectable } from '@angular/core'
import { createFrom, EventService } from '@spartacus/core'
import { filter, map, switchMap } from 'rxjs/operators'
import { Router } from '@angular/router'
import { ActiveCartService, CartPageEventBuilder } from '@spartacus/cart/base/core'
import { CartPageEvent } from '@spartacus/cart/base/root'

@Injectable({
  providedIn: 'root'
})
export class MbCartPageEventBuilder extends CartPageEventBuilder {

  constructor (protected eventService: EventService,
               protected activeCartService: ActiveCartService,
               protected router: Router) {
    super(eventService)
  }

  protected buildCartPageEvent () {
    return this.eventService.get(NavigationEvent).pipe(
      filter(navigationEvent => navigationEvent.semanticRoute === 'cart'),
      switchMap(navigation => this.activeCartService.getActive().pipe(
        filter(cart => Boolean(cart.code)),
        // since we don't take 1 cuz we wanna listen for qty change on cart we need to allow extra events only there
        filter(() => navigation.url === this.router.url),
        map(cart => createFrom(CartPageEvent, {
          navigation,
          cart,
          step: 1
        }))
      ))
    )
  }
}
